import { render } from "./homeSubTopicManager.vue?vue&type=template&id=524942d8&scoped=true"
import script from "./homeSubTopicManager.vue?vue&type=script&lang=js"
export * from "./homeSubTopicManager.vue?vue&type=script&lang=js"

import "./homeSubTopicManager.vue?vue&type=style&index=0&id=524942d8&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524942d8"]])

export default __exports__